/* eslint-disable angular/controller-name */
/* eslint-disable angular/controller-as */

(function iife() {
	"use strict";

	angular.module("dx.webapp.forgotPassword").
		controller("ForgotPasswordRouteController", ForgotPasswordRouteController);

	function ForgotPasswordRouteController(
		$scope,
		$http,
		validationService,
		dxDialog,
		DX_URLS,
		dxLocalize
	) {
		$scope.Urls = DX_URLS;

		$scope.requestInProgress = false;
		$scope.email = "";
		$scope.emailValid = false;

		$scope.requestSent = false;

		$scope.validateEmail = function validateEmail() {
			$scope.emailValid = validationService.isEmailValid($scope.email);
		};

		$scope.submit = function submit() {
			if (!$scope.emailValid || $scope.requestInProgress) {
				return;
			}

			$scope.requestInProgress = true;

			$http.post("/changepasswordtoken/create/", {email: $scope.email}).then(onSuccess, onError);

			function onSuccess(response) {
				$scope.requestInProgress = false;

				if (response.data.faults) {
					showErrorDialog(dxLocalize.get("UnknownError"), dxLocalize.get("UnknownErrorTryAgain"));
				} else {
					$scope.requestSent = true;
				}
			}

			function onError() {
				$scope.requestInProgress = false;
				showErrorDialog(dxLocalize.get("UnknownError"), dxLocalize.get("UnknownErrorTryAgain"));
			}
		};

		function showErrorDialog(title, body) {
			dxDialog.alert({
				title: title,
				body: body,
				acceptText: dxLocalize.get("Ok"),
			});
		}
	}
}());
